import "../styles/LoadingSvg2.scss";

const LoadingSvg2 = () => {
    return (
        <div className="svg-background">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
        </div>
    );
};

export default LoadingSvg2;
